// Digital Planning API — all calls go to /api/digital
const BASE = '/api/digital';

function getToken() { return localStorage.getItem('plan_token'); }

async function request(method, path, body, params) {
  const headers = { 'Content-Type': 'application/json' };
  const token = getToken();
  if (token) headers['Authorization'] = `Bearer ${token}`;
  
  let url = `${BASE}${path}`;
  if (params) {
    const qs = new URLSearchParams(params).toString();
    if (qs) url += '?' + qs;
  }

  const res = await fetch(url, {
    method, headers,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    localStorage.removeItem('plan_token');
    window.location.href = '/login';
    return;
  }
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || data.error || `HTTP ${res.status}`);
  return data;
}

export const digitalApi = {
  // Platforms (M1)
  getPlatforms:     (activeOnly = true)          => request('GET',  '/platforms', undefined, { active_only: activeOnly }),
  createPlatform:   (data)                       => request('POST', '/platforms', data),
  updatePlatform:   (id, data)                   => request('PATCH',`/platforms/${id}`, data),
  deletePlatform:   (id)                         => request('DELETE',`/platforms/${id}`),

  // Clients
  getClients:       ()                           => request('GET',  '/clients'),
  getClient:        (id)                         => request('GET',  `/clients/${id}`),
  createClient:     (data)                       => request('POST', '/clients', data),
  updateClient:     (id, data)                   => request('PATCH',`/clients/${id}`, data),
  deleteClient:     (id)                         => request('DELETE',`/clients/${id}`),

  // Plans (stored as JSON blobs per client, like TV)
  getPlans:         (clientId)                   => request('GET',  `/plans?client_id=${clientId}`),
  getPlan:          (id)                         => request('GET',  `/plans/${id}`),
  createPlan:       (data)                       => request('POST', '/plans', data),
  savePlan:         (id, data)                   => request('PATCH',`/plans/${id}`, data),
  deletePlan:       (id)                         => request('DELETE',`/plans/${id}`),
  submitPlan:       (id)                         => request('POST', `/plans/${id}/submit`),
  approvePlan:      (id)                         => request('POST', `/plans/${id}/approve`),
  rejectPlan:       (id)                         => request('POST', `/plans/${id}/reject`),
  archivePlan:      (id)                         => request('POST', `/plans/${id}/archive`),

  // Brands
  getBrands:        (clientId)                   => request('GET',  '/brands', undefined, clientId ? { client_id: clientId } : {}),
  createBrand:      (data)                       => request('POST', '/brands', data),
  updateBrand:      (id, data)                   => request('PATCH',`/brands/${id}`, data),

  // Flights (M2-M3)
  getFlights:       (brandId)                    => request('GET',  '/flights', undefined, brandId ? { brand_id: brandId } : {}),
  getFlight:        (id)                         => request('GET',  `/flights/${id}`),
  createFlight:     (data)                       => request('POST', '/flights', data),
  updateFlight:     (id, data)                   => request('PATCH',`/flights/${id}`, data),
  setPlatformMix:   (id, configs)                => request('PUT',  `/flights/${id}/platform-mix`, configs),
  calculateFlight:  (id, year = 2026)            => request('POST', `/flights/${id}/calculate`, null, { year }),
  lockFlight:       (id, lockedBy)               => request('POST', `/flights/${id}/lock`, { locked_by: lockedBy }),
  getBaselines:     (id)                         => request('GET',  `/flights/${id}/baselines`),

  // Pacing (M8)
  uploadActuals:    (flightId, uploadedBy, actuals) => request('POST', '/pacing/actuals', { flight_id: flightId, uploaded_by: uploadedBy, actuals }),
  getPacingSnapshot:(flightId)                   => request('GET',  `/pacing/${flightId}/snapshot`),
  getActuals:       (flightId)                   => request('GET',  `/pacing/${flightId}/actuals`),
  redistribute:     (flightId, method, by, notes) => request('POST', `/pacing/${flightId}/redistribute`, { flight_id: flightId, method, applied_by: by, notes }),
  getRedistLog:     (flightId)                   => request('GET',  `/pacing/${flightId}/redistribution-log`),

  // Reports (M6)
  clientSummary:    (clientId)                   => request('GET',  `/reports/client/${clientId}/summary`),
};
